"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.explorerPresetCreate = exports.explorerPresetRemove = exports.explorerPresetUpdate = exports.explorerPresetGet = exports.getExplorerPresetsByType = exports.searchSocialUsersExplorer = void 0;
var endpoints_1 = require("Modules/explorers/api/endpoints");
var axios_1 = __importDefault(require("axios"));
var searchSocialUsersExplorer = function (_a) {
    var _b = _a.query, query = _b === void 0 ? "" : _b, _c = _a.page, page = _c === void 0 ? 1 : _c, _d = _a.perPage, perPage = _d === void 0 ? 25 : _d, _e = _a.additionalParams, additionalParams = _e === void 0 ? {} : _e;
    return axios_1.default
        .get(endpoints_1.endpoints.searchSocialUsersExplorer, {
        params: __assign({ search: query, page: page, perPage: perPage }, additionalParams),
    })
        .then(function (res) { return res.data; });
};
exports.searchSocialUsersExplorer = searchSocialUsersExplorer;
var getExplorerPresetsByType = function (type) {
    var filters = JSON.stringify({ type: type });
    return axios_1.default
        .get(endpoints_1.endpoints.getExplorerPresets, {
        params: { filters: filters, page: 1, perPage: 10000 },
    })
        .then(function (res) { return res.data; });
};
exports.getExplorerPresetsByType = getExplorerPresetsByType;
var explorerPresetGet = function (id) {
    return axios_1.default
        .get(endpoints_1.endpoints.explorerPresetGet(id))
        .then(function (res) { return res.data; });
};
exports.explorerPresetGet = explorerPresetGet;
var explorerPresetUpdate = function (_a) {
    var id = _a.id, columns = _a.columns, name = _a.name, type = _a.type;
    return axios_1.default.post(endpoints_1.endpoints.explorerPresetUpdate(id), {
        columns: columns,
        name: name,
        type: type,
    });
};
exports.explorerPresetUpdate = explorerPresetUpdate;
var explorerPresetRemove = function (id) {
    return axios_1.default.delete(endpoints_1.endpoints.explorerPresetRemove(id));
};
exports.explorerPresetRemove = explorerPresetRemove;
var explorerPresetCreate = function (payload) {
    var data = __assign(__assign({}, payload), { columns: payload.columns });
    return axios_1.default
        .post(endpoints_1.endpoints.explorerPresetCreate, data)
        .then(function (res) { return res.data.data; });
};
exports.explorerPresetCreate = explorerPresetCreate;
